import axiosInstance from 'config/AxiosConfig';
import { StoreDirectorySupplyMonitorReq } from 'domain/payload/request/clientTransmora/storeDirectorySupplyMonitor/StoreDirectorySupplyMonitorReq';
import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import { SupplyMonitorMerchantPartnerResp, SupplyMonitorResp } from 'domain/payload/response/clientTransmora/storeDirectorySupplyMonitor/SupplyMonitorResp';
import { SupplyMonitorAreaListResp } from 'domain/payload/response/clientTransmora/storeDirectorySupplyMonitor/SupplyMonitorAreaListResp';
import { SupplyMonitorFilterResp } from 'domain/payload/response/clientTransmora/storeDirectorySupplyMonitor/SupplyMonitorFilterResp';
import { SupplyMonitorAreaHierarchyResp } from 'domain/payload/response/clientTransmora/storeDirectorySupplyMonitor/SupplyMonitorAreaHierarchyResp';

const StoreDirectorySupplyMonitorService = () => {
  const SupplyMonitor = async (
    token: string,
    request: StoreDirectorySupplyMonitorReq
  ): Promise<BaseResponse<SupplyMonitorResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/perfect-store-supply-monitor/data`, request, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const SupplyMonitorAreaList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null,
    groupBy: string | null,
    balanceFilter: string | null,
    sortBy: string | null,       
    sortOrder: string | null,
    request: StoreDirectorySupplyMonitorReq
  ): Promise<BaseResponse<SupplyMonitorAreaListResp[]>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/perfect-store-supply-monitor/area-list`, request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { search, page, size, groupBy, balanceFilter, sortBy, sortOrder },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const SupplyMonitorFilterConfig = async (
    token: string
  ): Promise<BaseResponse<SupplyMonitorFilterResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/perfect-store-supply-monitor/filter-config`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const SupplyMonitorAreaMerchantPartnerList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null,
    areaIds: string[]
  ): Promise<BaseResponse<SupplyMonitorMerchantPartnerResp[]>> => {
    try {
      const response = await axiosInstance.post(
        `/v1/legacy/cms/perfect-store-supply-monitor/area-merchant-partner-list`,
        { areaIds },
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { search, page, size },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const SupplyMonitorAreaHierarchy = async (
    token: string,
    areaId: string
  ): Promise<BaseResponse<SupplyMonitorAreaHierarchyResp>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/perfect-store-supply-monitor/area-hierarchy`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { areaId },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return {
     SupplyMonitor, 
     SupplyMonitorAreaList,
     SupplyMonitorFilterConfig,
     SupplyMonitorAreaMerchantPartnerList,
     SupplyMonitorAreaHierarchy
    };
};

export default StoreDirectorySupplyMonitorService;